/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateFragmentCreationMutationRequest, CreateFragmentCreationMutationResponse } from "../models/CreateFragmentCreation";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createFragmentCreation } from "../axios/createFragmentCreation";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createFragmentCreationMutationKey = () => ["web-app-bff-api", { url: '/fragments' }] as const

export type CreateFragmentCreationMutationKey = ReturnType<typeof createFragmentCreationMutationKey>

export function createFragmentCreationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateFragmentCreationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createFragmentCreationMutationKey()
        return mutationOptions<CreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, {data: CreateFragmentCreationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createFragmentCreation(data, config)
          },
        })

}

/**
 * @summary Create a fragment
 * {@link /fragments}
 */
export function useCreateFragmentCreation<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, {data: CreateFragmentCreationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateFragmentCreationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createFragmentCreationMutationKey()

          const baseOptions = createFragmentCreationMutationOptions(config) as UseMutationOptions<CreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, {data: CreateFragmentCreationMutationRequest}, TContext>
          

          return useMutation<CreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, {data: CreateFragmentCreationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, {data: CreateFragmentCreationMutationRequest}, TContext>
      
}